module.exports = __webpack_public_path__ + "static/media/IMG_1770-min.aab9fe5a.jpg";